import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { StoryHeadline, Reveal, StoryPhoto, usePick, bodyText, eyebrowText } from './StoryShared';
import { TeamMarkers } from './StoryVisuals';
import { trackEvent as track } from '../../utils/analytics';
import { act5, closing, storyImages, LOGO_ATNA } from '../../data/storyPage';

/* Act 5 (the team) + the emotional close */
export function StoryToday() {
  const pick = usePick();
  return <>
      {/* Act 5 — who we are today */}
      <section className="px-6 py-20 lg:py-28" aria-labelledby="story-team" data-id="element-6729" data-mp="2w0wb1mnd5rd6">
        <div className="max-w-7xl mx-auto" data-id="element-6730" data-mp="2r1t4tyvndf3m">
          <Reveal data-id="element-6731" data-mp="2r4p1ljvrdxqh">
            <StoryHeadline id="story-team" size="xl" lines={act5.headline} data-id="element-6732" data-mp="2m3j7piqd44fd" />
          </Reveal>
          <Reveal delay={0.05} className="mt-10 lg:mt-12" data-id="element-6733" data-mp="2m5vuqaaz94za">
            <StoryPhoto src={storyImages.team} alt={pick(act5.imageAlt)} aspect="aspect-[4/3] md:aspect-[21/9]" data-id="element-6734" data-mp="papqozmjtieb" />
          </Reveal>
          <div className="mt-6" data-id="element-6735" data-mp="kabtkcmhjsv2"><TeamMarkers data-id="element-6736" data-mp="qd5w218l0hcg" /></div>
          <Reveal className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-14 max-w-6xl" data-id="element-6737" data-mp="qbuso2j1tblv">
            <p className={bodyText} data-id="element-6738" data-mp="vd0nc5w9r8y1">{pick(act5.place)}</p>
            <p className={bodyText} data-id="element-6739" data-mp="geq6w3t47i5l">{pick(act5.partners)}</p>
          </Reveal>
        </div>
      </section>

      {/* Closing */}
      <section className="px-6 pt-16 lg:pt-20 pb-24 lg:pb-32 bg-[#FCFBFF] border-t border-[#EEF0F4]" aria-labelledby="story-close" data-id="element-6740" data-mp="ld038hqksoss">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-[0.85fr_1.15fr] gap-10 lg:gap-14 items-center" data-id="element-6741" data-mp="193vyjou8q24s">
          <Reveal data-id="element-6742" data-mp="1e4bd2jq9dfoc">
            <p className={eyebrowText} data-id="element-6743" data-mp="zducf2lg6tsi">{pick(closing.eyebrow)}</p>
            <StoryHeadline id="story-close" size="md" lines={closing.headline} className="mt-4" data-id="element-6744" data-mp="zdawtsj9shhn" />
            <p className={`mt-6 max-w-[460px] ${bodyText}`} data-id="element-6745" data-mp="14aulznhiaeod">{pick(closing.body)}</p>
            <p className={`mt-5 ${bodyText}`} data-id="element-6746" data-mp="1s0ovpw6j3n4e">
              {closing.changed.map(c => <span key={c.fr} className="block" data-id="element-6747" data-mp="1wtqcyau7jyr5">{pick(c)}</span>)}
              <span className="block font-semibold text-[#121A3A]" data-id="element-6748" data-mp="26nvxbba4j8qm">{pick(closing.obsession)}</span>
            </p>
          </Reveal>
          <Reveal delay={0.05} data-id="element-6749" data-mp="21qnc11toiol5">
            <StoryPhoto src={storyImages.horizon} alt={pick(closing.imageAlt)} aspect="aspect-[16/9]" data-id="element-6750" data-mp="1xo8xuv0ygd07">
              <img src={LOGO_ATNA} alt="" aria-hidden="true" className="absolute w-[13%] h-auto object-contain brightness-0 invert opacity-90" style={{
              left: '66%',
              top: '72%'
            }} data-id="element-6751" data-mp="1spfqzlg6bk90" />
            </StoryPhoto>
          </Reveal>
        </div>

        <Reveal className="max-w-7xl mx-auto mt-20 lg:mt-28" data-id="element-6752" data-mp="1e1b568ltqsm0">
          <StoryHeadline as="p" lines={closing.promise} size="xl" className="!text-[3rem] sm:!text-[4.4rem] lg:!text-[6.2rem] !leading-[0.98]" data-id="element-6753" data-mp="19yo7vs6dwfhf" />
          <Link to="/request-demo" onClick={() => track('Demo CTA Clicked', {
          location: 'Our Story Final CTA'
        })} className="mt-12 inline-flex w-full sm:w-auto items-center justify-center gap-3 rounded-md bg-[#4F46E5] px-8 py-4 font-sans text-[16px] font-medium text-white hover:bg-[#4338CA] transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#4F46E5] focus-visible:ring-offset-2" data-id="element-6754" data-mp="14ya2khw63jn3">
            {pick(closing.cta)}
            <ArrowRightIcon className="w-4 h-4 shrink-0" aria-hidden="true" data-id="element-6755" data-mp="3pmbmi47oo7ts" />
          </Link>
        </Reveal>
      </section>
    </>;
}